export const generateFontColor = (color: string) => {
    const darknessThreshold = 170;
    const lightFontColor = '#ffffff';
    const darkFontColor = '#1c1c1c';
    const rgb = parseInt(color.substring(1), 16);

    if (
        0.2126 * ((rgb >> 16) & 0xff) +
            0.7152 * ((rgb >> 8) & 0xff) +
            0.0722 * ((rgb >> 0) & 0xff) <
        darknessThreshold
    ) {
        return lightFontColor;
    }

    return darkFontColor;
};
